import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { Link } from '@/global/components/Link'
import { Badge } from '@/global/components/ui/badge'
import IconeAjuda from 'global/components/IconeAjuda'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { SettingsIcon } from 'lucide-react'
import { useMemo } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Rubrica, rubrica } from 'service/api'
import ExportarRubrica from 'templates/Cadastro/Rubricas/atoms/ExportarRubrica'
import { CommitService as useService } from 'templates/Cadastro/Rubricas/service/commit'

export default function Rubricas() {
    const { data = [], isLoading } = rubrica.useFetch()
    const { handleSubmit: handleEditCommit } = useService()
    const prioridade = ['Horas extras', 'Falta em horas']

    const rows = useMemo(() => {
        if (!data?.length) return []
        return data.sort((a, b) => {
            if (prioridade.includes(a.referencia)) return -1
            if (prioridade.includes(b.referencia)) return 1
            return a.referencia.localeCompare(b.referencia)
        })
    }, [data])

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Rubricas']}>
                    <IconeAjuda>
                        Se a empresa não separar as horas extras por tipo,
                        utilize o campo <strong>Horas extras</strong>.&nbsp;
                        {hasPermission(['update', 'Empresas']) && (
                            <Link href="empresas">Alterar configuração</Link>
                        )}
                        {hasPermission(['update', 'Rubricas']) && (
                            <>
                                <br />
                                <br />
                                Clique sobre campo <strong>Código</strong>
                                &nbsp;para editar.
                            </>
                        )}
                    </IconeAjuda>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={[
                        {
                            field: 'exportar',
                            headerName: 'Exportar',
                            width: 80,
                            renderCell: ExportarRubrica,
                            headerAlign: 'center',
                            align: 'center',
                            disableColumnMenu: true,
                            type: 'SN',
                        },
                        {
                            field: 'codigo',
                            headerName: 'Código',
                            width: 150,
                            editable: hasPermission(['update', 'Rubricas']),
                            type: 'number',
                        },
                        {
                            field: 'referencia',
                            headerName: 'Descrição',
                            flex: 1,
                        },
                        {
                            ...optionsColumn,
                            field: '__excecoes',
                            renderCell: ({
                                id,
                                row: { ExcecaoRubrica = [] },
                            }) => (
                                <IconButton
                                    href={`${id}/excecoes`}
                                    title="Gerenciar exceções"
                                    className="relative"
                                >
                                    <Badge className="absolute top-0.5 right-0.5 size-5">
                                        {ExcecaoRubrica.length}
                                    </Badge>
                                    <SettingsIcon />
                                </IconButton>
                            ),
                        },
                    ]}
                    rows={rows}
                    onCellEditCommit={handleEditCommit}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-rubricas',
                        },
                        showQuickFilter: true,
                    }}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useRubricasOutletContext() {
    return useOutletContext<{ data: Rubrica[] }>()
}
